<style lang="scss" scoped>
.form-control {
  height: 40px;
}
</style>

<template>
  <div>
    <label class="form-label">{{ label || "Rollen" }}</label>
    <select v-model="selectedRoles" multiple>
      <option v-for="(role, index) in roles" :value="role.name" :key="index">
        {{ role.name }}
      </option>
    </select>
  </div>
</template>

<script lang="babel">
export default {
  created() {
    this.$store.dispatch("roles/read");
  },
  props: {
    value: null,
    label: null,
    id: null,
    attributes: null,
    name: {
      required: false,
      default: 'role'
    }
  },
  computed: {
    roles() {
      return this.$store.getters["roles/all"];
    },
    selectedRoles: {
      get() {
        return this.value || [];
      },
      set(newVal) {
        this.$emit('filter-change', {
          id: this.id,
          name: this.name,
          attributes: this.attributes,
          value: newVal
        });
      }
    }
  },
  methods: {
    apply(event) {
      this.emitFilter(event);
    },
  }
};
</script>
